"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Table/Table.css"));
var widths = function (columns, columnBorders) {
    var widths = [];
    for (var i = 0; i < columns; i++) {
        var width = columnBorders[i + 1] - columnBorders[i];
        widths.push(width);
    }
    return widths;
};
var Table = function (_a) {
    var cells = _a.cells, columns = _a.columns, columnBorders = _a.columnBorders, attributes = _a.attributes, style = _a.style;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, "qwilr-table-scroller") }),
        react_1.default.createElement("table", { className: (0, classnames_1.default)("qwilr-table", styles.qwilrTable({
                backgroundOn: style.background.on,
                borderType: style.border.borderType,
                headerBackgroundOn: style.header.on,
            })) },
            react_1.default.createElement("colgroup", null, widths(columns, columnBorders).map(function (width) { return (react_1.default.createElement("col", { style: { width: "".concat(width, "%") } })); })),
            react_1.default.createElement("tbody", null, cells.map(function (row, rowIndex) { return (react_1.default.createElement("tr", { className: (0, classnames_1.default)({ "table-header-row": rowIndex === 0 }) }, row.map(function (cell) { return (react_1.default.createElement(react_1.default.Fragment, null, cell ? (react_1.default.createElement("td", { dangerouslySetInnerHTML: { __html: cell } })) : (react_1.default.createElement("td", null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("br", null)))))); }))); })))));
};
exports.default = Table;
